import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n, { setLanguage } from './i18n'

import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Activar esto solo para consumir json externo (API)
// import axios from 'axios'
// import VueAxios from 'vue-axios'
// Vue.use(VueAxios, axios)

Vue.config.productionTip = false

// use beforeEach route guard to set the language
router.beforeEach((to, _, next) => {
  // use the language from the routing param, localStorage, or default language
  let language = to.params.lang || localStorage.getItem('language') || 'es';
  
  // Si el idioma es diferente al actual, lo cambiamos y lo guardamos en localStorage
  if (i18n.locale !== language) {
    setLanguage(language); // Usamos la función para cambiar el idioma y guardar en localStorage
  }

  next();
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
